import { EntityModel } from '@/interfaces'
import {
  ALL_PACKAGES_QUERY,
  CREATE_PACKAGE_MUTATION,
  DELETE_PACKAGE_MUTATION,
  FORCE_DELETE_PACKAGE_MUTATION,
  SINGLE_PACKAGE_QUERY,
  UPDATE_PACKAGE_MUTATION,
} from './graphql'
import ratioAccommodationEntity from '@/entities/ratioAccommodation/entity'
import accommodationCapacitySettingsEntity from '@/entities/accommodationCapacitySettings/entity'
import ratioAccommodationAddonEntity from '@/entities/ratioAccommodationAddon/entity'

const ratioFamilyPackageModel: EntityModel = {
  name: 'package',
  namePlural: 'packages',
  uniqueName: 'ratioFamilyPackage',
  uniqueNamePlural: 'ratioFamilyPackages',
  path: 'travel/pricing/adaptors/ratio/package',
  baseUrl: '/travel/pricing/adaptors/ratio/packages',
  translationPrefix: 'entities:ratioFamilyPackage.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_PACKAGES_QUERY,
    getSingle: SINGLE_PACKAGE_QUERY,
    create: CREATE_PACKAGE_MUTATION,
    update: UPDATE_PACKAGE_MUTATION,
    delete: DELETE_PACKAGE_MUTATION,
    forceDelete: FORCE_DELETE_PACKAGE_MUTATION,
  },
  attributes: {
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioFamilyPackage.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    accommodation: {
      name: 'accommodation',
      label: 'entities:ratioFamilyPackage.attributes.accommodation.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioAccommodationEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:ratioFamilyPackage.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioFamilyPackage.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioFamilyPackage.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    capacitySettings: {
      name: 'capacitySettings',
      label: 'entities:ratioFamilyPackage.attributes.capacitySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return accommodationCapacitySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    addons: {
      name: 'addons',
      label: 'entities:ratioFamilyPackage.attributes.addons.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioAccommodationAddonEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioFamilyPackageModel
